module.exports = __webpack_public_path__ + "static/1st-242c03bcf101e7d04bc69c9287c8d36a.png";